// palette.ts ↔ game/misc.cpp gaclr24bpp + gaiclrSide (:1429) + the ht.h
// GetColor/GetSideColor inlines (:8682-8689). The web client's fixed palette is
// the 24bpp static table for every shipped depth (game.cpp:1218-1235 routes
// 8/24/32 bpp to gaclr24bpp). Extracted programmatically into palette.json
// (client/tools/gen-palette.mjs).

import palette from './palette.json' with { type: 'json' };
import type { Color } from './texatlasmgr.ts';

const gaclrFixed: Color[] = palette.colors;
const gaiclrSide: number[] = palette.gaiclrSide;

/** res.h kiclr* indices by name (kiclrBlack, kiclrWhite, kiclrSide1, …). */
export const iclr: Record<string, number> = palette.iclr;

// ht.h:8682-8684
export function GetColor(i: number): Color {
  return gaclrFixed[i];
}

// ht.h:8686-8689
export function GetSideColor(side: number): Color {
  return GetColor(gaiclrSide[side]);
}
